import { ErrorCode, ErrorHandler, ERROR_MESSAGES } from '@/types/error';
import { ApiResponse } from '@/types/api';

// エラーハンドラーの初期化
let globalErrorHandler: ErrorHandler | null = null;

// エラーハンドラーの設定関数
export const setErrorHandler = (handler: ErrorHandler) => {
  globalErrorHandler = handler;
};

// エラー処理の共通関数
export const handleError = <T = never>(error: unknown, errorCode: ErrorCode): ApiResponse<T> => {
  if (globalErrorHandler) {
    globalErrorHandler(error, errorCode);
  } else {
    console.error(`[Error] ${errorCode}:`, error);
  }
  return {
    success: false,
    message: ERROR_MESSAGES[errorCode]
  };
};
